import { useApi } from "../../../lib/api"
import { useMemo } from "react"
import { useParams } from "react-router-dom"

export function usePlayer(ClientUuid: string | undefined) {
  const { id } = useParams()
  const [response, error, loading, retry] = useApi(`/clients/` + ClientUuid + `/players-report/${id}/Mobile`)

  const data = useMemo(() => response?.data ?? [], [response?.data])

  return useMemo(() => [data, error, loading, retry], [data, error, loading, retry])
}

export interface Player {
  country: string
  countryCode: string
  wifiMacAddress: string
  deviceID: string
  displayName: string
  externalID: string
  firmwareVersion: string
  ipAddress: string
  lastConnection: string
  macAddress: string
  modelName: string
  serviceName: string
  name: string
  online: boolean
  isDHCP: boolean
  productName: string
  publicIp: string
  serialNumber: string
  siteUuid: string
  status: number
  subscriptionName: string
  timeZone: string
}
